"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Configure___StyledSvg",
  componentId: "sc-1icr8k7-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function Configure(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5.167a2.411 2.411 0 01-2.4 2.416 2.396 2.396 0 01-2.252-1.61H2V4.36h11.348A2.396 2.396 0 0115.6 2.75c1.323 0 2.4 1.084 2.4 2.417zm-1.6 0a.804.804 0 00-.8-.806c-.44 0-.8.362-.8.806 0 .445.36.805.8.805.44 0 .8-.36.8-.805zM7.6 7.583c-1.042 0-1.92.675-2.252 1.611H2v1.612h3.348a2.397 2.397 0 002.252 1.61c1.04 0 1.92-.674 2.252-1.61H18V9.194H9.852A2.396 2.396 0 007.6 7.584zM6.8 10c0 .445.36.806.8.806.44 0 .8-.36.8-.806a.804.804 0 00-.8-.806c-.44 0-.8.362-.8.806zM15.6 12.417c-1.042 0-1.92.675-2.252 1.61H2v1.612h11.348A2.397 2.397 0 0015.6 17.25c1.323 0 2.4-1.084 2.4-2.417a2.411 2.411 0 00-2.4-2.416zm-.8 2.416c0 .446.36.806.8.806.44 0 .8-.36.8-.806a.804.804 0 00-.8-.805c-.44 0-.8.361-.8.805z",
    fill: "currentColor"
  }));
}

var _default = Configure;
exports["default"] = _default;